<app-breadcrumb [title]="'Competencia'" [items]="['Pesv']" [active_item]="'Competencia'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="icofont icofont-star me-2"></i>
        <h5 class="mb-0"><strong>COMPETENCIA</strong></h5>
      </div>
    </div>

    <div class="card-body">

      <div *ngIf="cargandoListado" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 mb-0">Cargando competencias...</p>
      </div>

      <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
            <option [ngValue]="null">Todos</option>
            <option [ngValue]="1">Activos</option>
            <option [ngValue]="0">Inactivos</option>
          </select>
        </div>
        <div class="col-md-4 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar por descripción..."
              [(ngModel)]="filtro" (input)="aplicarFiltro()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="!cargandoListado" class="table-responsive mt-2">
        <ng-container>
      <table id="tblCompetencia" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">DESCRIPCIÓN</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let competencia of competenciasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ competencia.descripcion || '-' }}</td>
                <td class="text-center">
                  <span class="badge rounded-pill" [ngClass]="competencia.estado === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ competencia.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                  </span>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-1">
                    <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                      *ngIf="competencia.estado === 1" ngbTooltip="Editar"
                      (click)="abrirModalEditar(modalCompetencia, competencia)">
                      <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                      *ngIf="competencia.estado === 1" ngbTooltip="Inactivar"
                      (click)="cambiarEstado(competencia, 0)">
                      <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                      *ngIf="competencia.estado !== 1" ngbTooltip="Activar"
                      (click)="cambiarEstado(competencia, 1)">
                      <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
       
        </ng-container>

        <ng-template #sinDatos>
          <div class="text-center py-4 text-primary">No hay competencias registradas.</div>
        </ng-template>
      </div>
<div class="d-flex justify-content-between align-items-center mt-4">
            <div class="d-flex align-items-center">
              <label for="pageSizeCompetencia" class="me-2">Mostrar:</label>
              <select id="pageSizeCompetencia" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
              </select>
              <span class="ms-2">registros por página</span>
            </div>

            <div class="text-center flex-grow-1">
              Total Registros:
              <a class="badge badge-primary"><b>{{ competenciasFiltradas?.length || 0 }}</b></a>
            </div>

            <div class="text-end paginador-personalizado">
              <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
            </div>
          </div>

          <div class="mt-4">
            <div class="btn-showcase text-center">
              <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                (click)="exportarExcel('tblCompetencia','listado_competencia')">
                <i class="icofont icofont-file-excel"></i> EXCEL
              </button>
              <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                (click)="exportToPDF('tblCompetencia','listado_competencia','Listado de competencias')">
                <i class="icofont icofont-file-pdf"></i> PDF
              </button>
              <button class="btn btn-outline-primary-2x" type="button" (click)="abrirModalCrear(modalCompetencia)">
        <i class="icofont icofont-plus me-1"></i> Nueva competencia
      </button>
            </div>
          </div>
    </div>
  </div>
</div>

<!-- Modal Crear / Editar -->
<ng-template #modalCompetencia let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="icofont" [ngClass]="modoEdicion ? 'icofont-edit' : 'icofont-plus'" style="margin-right: 8px;"></i>
      {{ modoEdicion ? 'Editar competencia' : 'Crear nueva competencia' }}
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="competenciaForm" novalidate>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label text-dark">
          Descripción: <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control text-uppercase" formControlName="descripcion"
          placeholder="Ingrese la descripción de la competencia"
          [class.is-invalid]="competenciaForm.get('descripcion')?.invalid && competenciaForm.get('descripcion')?.touched">
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="guardando">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="guardar(modal)" [disabled]="guardando">
        <span *ngIf="!guardando">
          <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
        </span>
        <span *ngIf="guardando">
          <span class="spinner-border spinner-border-sm me-1"></span>
          {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
        </span>
      </button>
    </div>
  </form>
</ng-template>